var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSchedule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19543",
    "data-name": "Group 19543",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.489,
    height: 52.732,
    viewBox: "0 0 65.489 52.732",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-laptop",
    d: "M49.358,40.55a4.95,4.95,0,0,0,4.936-4.936V10.936A4.95,4.95,0,0,0,49.358,6H9.872a4.95,4.95,0,0,0-4.936,4.936V35.615A4.95,4.95,0,0,0,9.872,40.55H0v4.936H59.229V40.55ZM9.872,10.936H49.358V35.615H9.872Z",
    transform: "translate(0 7.246)",
    fill: "#909faf"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_358",
    cx: 16.557,
    cy: 16.557,
    r: 16.557,
    transform: "translate(32.374)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-schedule",
    d: "M16.6,3A13.614,13.614,0,1,0,30.229,16.614,13.608,13.608,0,0,0,16.6,3Zm.014,24.506A10.892,10.892,0,1,1,27.506,16.614,10.889,10.889,0,0,1,16.614,27.506Zm.681-17.7H15.253v8.169L22.4,22.264l1.021-1.675L17.3,16.955Z",
    transform: "translate(32.686 -0.426)",
    fill: "#909faf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSchedule);
export default __webpack_public_path__ + "static/media/icon-schedule.58ed59bdf9d4cebc454733fea2056ed5.svg";
export { ForwardRef as ReactComponent };